import request from "@/utils/request";

export function login(data) {
    return request({
        url: "/auth/login",
        method: "post",
        data: data
    });
}

export function getInfo() {
    return request({
        url: "/auth/user",
        method: "get"
    });
}

export function logout() {
    return request({
        url: "/auth/logout",
        method: "post"
    });
}

export function reset(data) {
    return request({
        url: "/password/email",
        method: "post",
        data: data
    });
}

export function setNewPassword(data) {
    return request({
        url: "/password/reset",
        method: "post",
        data: data
    });
}

export function updatePassword(data) {
    return request({
        url: "profile/updatePassword",
        method: "post",
        data: data
    });
}

export function uploadAvatar(data) {
    return request({
        url: "profile/updateAvatar",
        method: "post",
        data: data
    });
}

export function getScoreStatistic() {
    return request({
        url: "user/getStatistic",
        method: "get"
    });
}

export function forgotPassword(email) {
    return request({
        url: "forgot_password",
        method: "post",
        data: { email }
    });
}

export function resetPassword(password, password_confirmation, token) {
    return request({
        url: "reset_password",
        method: "post",
        data: { password, token, password_confirmation }
    });
}
